import { css, styled } from 'styled-components'

const ToolbarPopoverWrapper = styled.div<{ $maximizeWidth?: boolean }>`
    padding: 12px 12px 8px;

    ${({ $maximizeWidth }) =>
        $maximizeWidth &&
        css`
            max-width: 100%;
            width: 300px;
        `}
`

export default ToolbarPopoverWrapper
